<style scoped>
    .ivu-col{
        padding: 5px;
    }
</style>
<style>
    .customer-contract-alert .ivu-table-cell{
        padding: 0 3px;
    }
</style>
<template>
  <div class="customer-contract-alert">
    <Button @click="getAlertInfos">
      刷新
    </Button>
    <Row>
      <i-col span="8">
        <div class="line text-large">
          合同已到期
        </div>
        <Table
          :columns="customer_columns"
          :data="customers_expired"
          size="small"
        />
      </i-col>
      <i-col span="8">
        <div class="line text-large">
          合同即将到期(30天)
        </div>
        <Table
          :columns="customer_columns"
          :data="customers_soon"
          size="small"
        />
      </i-col>
      <i-col span="8">
        <div class="line text-large">
          合同信息未录入
        </div>
        <Table
          :columns="customer_columns"
          :data="customers_with_no_careers"
          size="small"
        />
      </i-col>
    </Row>
    <Backdrop v-show="loading" />
  </div>
</template>
<script route="/hr/contract_alert">
  import Util from '../../libs/util';
  export default {
    /* router_info_start */
    router_info: '/hr/contract_alert',
    /* router_info_end */

    data() {
      return {
        loading: false,
        customers_expired: [],
        customers_soon: [],
        customers_with_no_careers: [],
        customer_columns: [
          {
            title: '工号',
            width: 68,
            key: 'uid'
          },
          {
            title: '姓名',
            key: 'account'
          },
          {
            title: '合同开始',
            width: 85,
            render: (h, params) => {
              return h('div', params.row.contract_start || '无');
            }
          },
          {
            title: '合同结束',
            width: 85,
            render: (h, params) => {
              return h('div', params.row.contract_end || '无');
            }
          }
        ]
      }
    },
    computed: {
      //
    },
    created() {
      this.getAlertInfos();
    },
    mounted() {
      //
    },
    methods: {
      getAlertInfos() {
        if (this.loading) {
          return;
        }
        this.loading = true;
        Util.ajax.get(Util.api.career_alert, {
          //
        }).then((response) => {
          return response.data;
        }).then((res) => {
          this.loading = false;
          if (res.code === 1) {
            const data = res.data;
            this.customers_expired = [];
            this.customers_soon = [];
            this.customers_with_no_careers = [];
            data.customers_expired.forEach((c) => {
              this.customers_expired.push(c);
            });
            data.customers_soon.forEach((c) => {
              this.customers_soon.push(c);
            });
            data.customers_with_no_careers.forEach((c) => {
              this.customers_with_no_careers.push(c);
            });
          } else {
            this.$Modal.error({
              title: '错误',
              content: res.msg
            });
          }
        }).catch((e) => {
          this.loading = false;
          console.log(e);
        });
      }
    }
  }
</script>
